var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.103 132.69H291.31V70.897a8.829 8.829 0 0 0-8.828-8.828h-52.966a8.829 8.829 0 0 0-8.828 8.828v61.793h-61.793a8.829 8.829 0 0 0-8.828 8.828v52.966a8.829 8.829 0 0 0 8.828 8.828h61.793v61.793a8.829 8.829 0 0 0 8.828 8.828h52.966a8.829 8.829 0 0 0 8.828-8.828V203.31h61.793a8.829 8.829 0 0 0 8.828-8.828v-52.966c0-4.874-3.953-8.826-8.828-8.826z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/ch.6cc6aeb1e6184360796117b4600b5448.svg";
export { ForwardRef as ReactComponent };